import { $translate } from '@/utils/i18n';
export const config = {
    searchList: {
        searchTxt: [],
        isInquire: false
    },
    table: {
        height: 200,
        selectBtn: false,
        leftWidth: 160,
        columns: [
            {
                label: $translate('lang.E3202110110003', { defaultText: '租户编码' }),
                prop: 'tenantNumberTxt',
                width: 200
            },
            {
                label: $translate('lang.E3202110110004', { defaultText: '数据表' }),
                prop: 'tableFlagTxt',
                width: 200
            },
            {
                label: $translate('lang.E3202110110005', { defaultText: '来源系统' }),
                prop: 'sourceSysTxt',
                width: 200
            }
        ],
        dialogColumns: [
            {
                label: $translate('lang.E3202110110003', { defaultText: '租户编码' }),
                prop: 'tenantNumber',
                require: true,
                span: 24,
                labelWidth: '106px'
            },
            {
                label: $translate('lang.E3202110110004', { defaultText: '数据表' }),
                prop: 'tableFlag',
                type: 'select',
                options: [],
                optionNum: 'TABLE_FLAG',
                require: true,
                span: 24,
                labelWidth: '106px'
            },
            {
                label: $translate('lang.E3202110110005', { defaultText: '来源系统' }),
                prop: 'sourceSys',
                type: 'select',
                options: [],
                optionNum: 'SOURCE_SYS',
                require: true,
                span: 24,
                labelWidth: '106px'
            }
        ],
        leftOperation: true,
        action: [
            {
                type: 'text',
                label: $translate('lang.E3202102260009', { defaultText: '编辑' }),
                event: 'edit',
                size: 'small'
            },
            {
                type: 'text',
                label: $translate('lang.E3202102230004', { defaultText: '删除' }),
                event: 'delete',
                size: 'small'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};